<div class="credentials">
  <!-- (onClose)="onClosePanel($event)" (onOpen)="onOpenPanel($event)" -->
  <p-accordion class="credentials-sidebar" [activeIndex]="activePanelIndex">
    <p-accordionTab>
      <p-header><span #snmpheader title="Primary network credentials (community strings) used for network device discovery and topology mapping.">SNMP Communities</span></p-header>
      @for (settings of allSnmpSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedSnmpSettings == settings"
                (click)="onSelectSnmpSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteSnmpSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddSnmpSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #snmpv3header title="Enhanced SNMP credentials that provide SNMPv3 support for network discovery.">SNMP V3 Users</span></p-header>
      @for (settings of allSnmpV3Settings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedSnmpV3Settings == settings"
                (click)="onSelectSnmpV3Settings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteSnmpV3Settings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddSnmpV3Settings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #sshheader title="Credentials used for capturing startup/running configurations from devices.&#013;In some cases these credentials may be used for discovery (when SNMP is not configured)">SSH</span></p-header>
      @for (settings of allSshSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedSshSettings == settings"
                (click)="onSelectSshSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteSshSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddSshSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #telnetheader  title="Credentials used for capturing startup/running configurations from devices.&#013;In some cases these credentials may be used for discovery (when SNMP is not configured)">Telnet</span></p-header>
      @for (settings of allTelnetSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedTelnetSettings == settings"
                (click)="onSelectTelnetSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteTelnetSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddTelnetSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #httpheader title="Credentials for using HTTP(s) to connect to devices or equipment platforms like Meraki Dashboard, ExtremeCloud IQ">HTTP / Platform API Keys</span></p-header>
      @for (settings of allHttpSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedHttpSettings == settings"
                (click)="onSelectHttpSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteHttpSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddHttpSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #vimheader title="VMware credentials to enable detailed VMware virtualization discovery including vSphere, Virtual Hosts, and Virtual Machines.">VMware</span></p-header>
      @for (settings of allVimSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedVimSettings == settings"
                (click)="onSelectVimSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteVimSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddVimSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #windowsheader title="Windows credentials used for enhanced Windows server and workstation discovery as well as Microsoft Hyper-V virtualizaion discovery.">Windows (WMI)</span></p-header>
      @for (settings of allWindowsSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedWindowsSettings == settings"
                (click)="onSelectWindowsSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeleteWindowsSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddWindowsSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
    <p-accordionTab>
      <p-header><span #prtgheader title="PRTG REST API credentials that allows UVexplorer to connect and export information to PRTG Network Monitor platform.">PRTG</span></p-header>
      @for (settings of allPrtgSettings; track settings) {
        <div class="settings-grid">
          <div class="form-group row credential-row">
            <div class="uv-row">
              <div>
                <i class="fa fa-arrow-right credential-arrow"></i>
                <span class="clickable-credentials-item" [class.active]="selectedPrtgSettings == settings"
                (click)="onSelectPrtgSettings(settings)">{{settings.Name}}</span>
              </div>
              <div style="flex-grow: 1;"></div>
              <div>
                <button class="btn btn-danger" (click)="onDeletePrtgSettings(settings)"
                  [disabled]="!isLicenseValid" title="Delete this credential">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      <button (click)="onAddPrtgSettings()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o"
      title="Create new credential"></button>
    </p-accordionTab>
  </p-accordion>

  @if (selectedSnmpSettings) {
    <snmp-settings #snmp [Settings]="selectedSnmpSettings"
    [AllowShowChars]="allowShowChars" (onApply)="onAppliedChange()"></snmp-settings>
  }

  @if (selectedSnmpV3Settings) {
    <snmp-v3-settings #snmpv3 [Settings]="selectedSnmpV3Settings"
    [AllowShowChars]="allowShowChars" (onApply)="onAppliedChange()"></snmp-v3-settings>
  }

  @if (selectedWindowsSettings) {
    <windows-settings #windows [Settings]="selectedWindowsSettings"
    [AllowShowChars]="allowShowChars" (onApply)="onAppliedChange()"></windows-settings>
  }

  @if (selectedVimSettings) {
    <vim-settings #vim [Settings]="selectedVimSettings" [AllowShowChars]="allowShowChars"
    (onApply)="onAppliedChange()"></vim-settings>
  }

  @if (selectedSshSettings) {
    <ssh-settings #ssh [Settings]="selectedSshSettings" [AllowShowChars]="allowShowChars"
    (onApply)="onAppliedChange()"></ssh-settings>
  }

  @if (selectedHttpSettings) {
    <http-settings #http [Settings]="selectedHttpSettings"
    [AllowShowChars]="allowShowChars" (onApply)="onAppliedChange()"></http-settings>
  }

  @if (selectedTelnetSettings) {
    <telnet-settings #telnet [Settings]="selectedTelnetSettings"
    [AllowShowChars]="allowShowChars" (onApply)="onAppliedChange()"></telnet-settings>
  }

  @if (selectedPrtgSettings) {
    <prtg-settings #prtg [Settings]="selectedPrtgSettings"
    [AllowShowChars]="allowShowChars" (onApply)="onAppliedChange()"></prtg-settings>
  }

  @if (noSelection) {
    <div
      style="order: 2; flex-grow: 1; text-align: center; padding-top: 100px; font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: x-large; overflow-x: hidden;">
      <div>Select a credential to view/edit its details, or</div>
      <div>Click &quot;New&quot; to create a new credential</div>
    </div>
  }

  <p-dialog [(visible)]="showTempChangesDialog">
    <p-header>
      <span>Unapplied Changes</span>
    </p-header>
    <p>Your changes have not been applied, and will be lost if you continue.</p>
    @if (!applyTempChangesEnabled) {
      <p>
        Some of the changes are currently invalid and cannot be applied.
      </p>
    }
    <p>Select one of the options below.</p>
    <p-footer>
      @if (applyTempChangesEnabled) {
        <button type="button" pButton [disabled]="!isLicenseValid"
        (click)="onApplyTempChanges()" label="Apply Changes"></button>
      }
      <button type="button" pButton (click)="onDiscardTempChanges()" label="Discard Changes"></button>
      <button type="button" pButton (click)="onCancelNavigation()" label="Cancel"></button>
    </p-footer>
  </p-dialog>

  <p-dialog [(visible)]="showDeleteNotAllowedDialog">
    <p-header>
      <span>Cannot Delete Credentials</span>
    </p-header>
    <p>
      These credentials cannot be deleted because they are still being used
      by the following discoveries:
    </p>
    <ul>
      @for (psRef of protocolSettingsReferences; track psRef) {
        <li>{{psRef}}</li>
      }
    </ul>
    <p-footer>
      <button type="button" pButton (click)="onCancelDeleteSettings()" label="OK"></button>
    </p-footer>
  </p-dialog>

</div>
